import { createReducer } from '../helpers/redux-helpers'
import { FsCore } from '../../types/fs-core'
import * as act from './sort-actions'

export const sortReducer = createReducer<FsCore.ElasticSearchState>(
  {
    [act.SET_SORT]: (state, payload) => ({ ...state, selectedSort: payload }),
  },
  {
    queries: {},
    productDataSet: {},
    isLoading: false,
    isErrored: false,
  },
)
